import {useEffect, useState} from "react";
import {erc20Abi, formatUnits} from 'viem'

import {createPublicClient, http, } from 'viem'
import {getConfig} from "../firebase";

// Multicall3 standard address

const getClient = (rpc) => {
  return createPublicClient({
    transport: http(rpc),
    batch: {
      multicall: true,  // Enable multicall batching of eth_call requests
    },
  })
}

async function getBalancesForUser(_address, muticallAddress, tokens, rpc) {
  const client = await getClient(rpc)
  const entries = Object.entries(tokens)

  const balanceResults = await client.multicall({
    multicallAddress: muticallAddress,
    allowFailure: true,
    contracts: entries.map(([_, address]) => ({
      address,
      abi: erc20Abi,
      functionName: 'balanceOf',
      args: [_address],
    })),
  })
  const result = {}

  entries.forEach(([symbol], i) => {
    const raw = balanceResults[i].status === 'success' ? (balanceResults[i].result ) : 0n
    result[symbol] = formatUnits(raw, 18)
  })

  return result

}

// usage
export const useGetBalance = () => {
  const [userAddress, setUserAddress] = useState(null)
  const [balance, setBalance] = useState({stick: 0, carrot: 0, magic: 0})


  useEffect(() => {
    const savedData = localStorage.getItem("userData")
    if (savedData) {
      const dataJson = JSON.parse(savedData)
      if (dataJson.wallet_address) {
        setUserAddress(dataJson.wallet_address)
        getConfig().then(config => {
          getBalancesForUser(dataJson.wallet_address,config.mc3, config.tokens, config.rpc).then(setBalance)

        })
      }
    }
  }, [])

  return {
    userAddress,
    balance,
  }
}
